// extracted by mini-css-extract-plugin
module.exports = {"input":"BMICalculator_input__W8QyT","label":"BMICalculator_label__k7ubr"};